module.exports = __webpack_public_path__ + "static/media/wiline.2811de5a.webp";